/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { updateStopListRequestSchema } from "./updateStopListRequestSchema.ts";
import { updateStopListSchema } from "./updateStopListSchema.ts";

export const callbackPluginUpdateStopListCreateStatus200Schema = updateStopListSchema;

export const callbackPluginUpdateStopListCreateResponseSchema = callbackPluginUpdateStopListCreateStatus200Schema;

export const callbackPluginUpdateStopListCreateDataSchemaJson = updateStopListRequestSchema;

export const callbackPluginUpdateStopListCreateDataSchemaXml = updateStopListRequestSchema;

export const callbackPluginUpdateStopListCreateDataSchema = z.union([
	callbackPluginUpdateStopListCreateDataSchemaJson,
	callbackPluginUpdateStopListCreateDataSchemaXml,
]);
